import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { editCampanaBonoTutoriaAPI, editSolicitudBonoTutoriaAPI, getSolicitudBonoTutoriaToEditAPI } from "../../../../consumers/backendApisUrls";
import BaseSolicitudes from "./BaseSolicitudes";
import { useManageGetRequest } from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import { usePropsInputs } from "../../../../hooks/useProps/usePropsInput";
import { useSubmitForm } from "../../../../hooks/useSubmitForm/useSubmitForm";

const EditSolicitudBonoTutoria = ({ toggleModal, refreshPage, IdSolicitudBonoTutoria, IdCampanaBonoTutoria ,fechasTutoria}) => {
    const SECTION_NAME = "EditSolicitudBonoTutoria";

    const [formValues, setFormValues] = useState({});
    const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
    const [isLoading, setIsLoading] = useState(true);
    const [submitForm] = useSubmitForm();
    const [executeGet] = useManageGetRequest();

    const KEYS = {
        Area: "Area",
        CampanaBonoTutoria: "CampanaBonoTutoria",
        Cargo: "Cargo",
        EstadoRegistro: "EstadoRegistro",
        FechaCrea: "FechaCrea",
        FechaIngresoTrabajo: "FechaIngresoTrabajo",
        FechaModifica: "FechaModifica",
        FechaCrea: "FechaCrea",
        UsuarioCrea: "UsuarioCrea",
        UsuarioModifica: "UsuarioModifica",
        FechaTutorFin: "FechaTutorFin",
        FechaTutorInicio: "FechaTutorInicio",
        IdCampanaBonoTutoria: "IdCampanaBonoTutoria",
        IdEmpleado: "IdEmpleado",
        IdSede: "IdSede",
        IdSolicitudBonoTutoria: "IdSolicitudBonoTutoria",
        NombreCompleto: "NombreCompleto",
        NombreSede: "NombreSede",
        PuedeEditar: "PuedeEditar"
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const api = editSolicitudBonoTutoriaAPI();
        const payload = getPayload();
        try {
            await submitForm(
                Object.values(KEYS),
                api,
                payload,
                SECTION_NAME,
                successSubmit
            );
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    const getPayload = () => {
        return {
            IdSolicitudBonoTutoria: formValues[KEYS.IdSolicitudBonoTutoria],
            FechaTutorInicio: formValues[KEYS.FechaTutorInicio],
            FechaTutorFin: formValues[KEYS.FechaTutorFin],
            IdCampanaBonoTutoria: formValues[KEYS.IdCampanaBonoTutoria],
            IdEmpleado: formValues[KEYS.IdEmpleado],
            FechaModifica: formValues[KEYS.FechaModifica],
            FechaCrea: formValues[KEYS.FechaCrea],
            UsuarioCrea: formValues[KEYS.UsuarioCrea],
            UsuarioModifica: formValues[KEYS.UsuarioModifica],
        }
    }
    const successSubmit = async () => {
        toggleModal();
        await refreshPage();
    };

    const init = async () => {
        setIsLoading(true)
        await executeGet(getSolicitudBonoTutoriaToEditAPI(IdSolicitudBonoTutoria), successInitCallback)
        setIsLoading(false)
    };

    const successInitCallback = ({ data }) => {
        setFormValues(prev => ({
            ...prev,
            Area: data.Area,
            CampanaBonoTutoria: data.CampanaBonoTutoria,
            Cargo: data.Cargo,
            EstadoRegistro: data.EstadoRegistro,
            FechaCrea: data.FechaCrea,
            FechaIngresoTrabajo: data.FechaIngresoTrabajoDate,
            FechaModifica: data.FechaModifica,
            FechaCrea: data.FechaCrea,
            UsuarioCrea: data.UsuarioCrea,
            UsuarioModifica: data.UsuarioModifica,
            FechaTutorFin: data.FechaTutorFinDate,
            FechaTutorInicio: data.FechaTutorInicioDate,
            IdCampanaBonoTutoria: data.IdCampanaBonoTutoria,
            IdEmpleado: data.IdEmpleado,
            IdSede: data.IdSede,
            IdSolicitudBonoTutoria: data.IdSolicitudBonoTutoria,
            NombreCompleto: data.NombreCompleto,
            NombreSede: data.NombreSede,
            PuedeEditar: data.PuedeEditar
        }));
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <BaseSolicitudes
            title="Editar nueva campaña"
            toggleModal={toggleModal}
            handleSubmit={handleSubmit}
            sectionName={SECTION_NAME}
            formValues={formValues}
            setFormValues={setFormValues}
            commonProps={commonProps}
            KEYS={KEYS}
            nuevo={false}
            successSubmit={successSubmit}
            IdSolicitudBonoTutoria={IdSolicitudBonoTutoria}
            fechasTutoria={fechasTutoria}
        />
    )
}
export default EditSolicitudBonoTutoria;